import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Clock, Eye, ArrowUpRight } from "lucide-react";

const CATEGORIES = {
  "stand-tasarimi": "Stand Tasarımı",
  "lojistik": "Lojistik",
  "sektor-trendleri": "Sektör Trendleri",
  "teknoloji": "Teknoloji",
  "surdurulebilirlik": "Sürdürülebilirlik",
  "pazar-analizi": "Pazar Analizi",
};

const timeAgo = (iso) => {
  const diff = Date.now() - new Date(iso).getTime();
  const hours = Math.floor(diff / (1000 * 60 * 60));
  if (hours < 1) return "Az önce";
  if (hours < 24) return `${hours} saat önce`;
  const days = Math.floor(hours / 24);
  if (days === 1) return "Dün";
  return `${days} gün önce`;
};

export const NewsCard = ({ article }) => {
  return (
    <Link
      to={`/haber/${article.slug || article.id}`}
      className="news-card group block bg-white border border-stone-200 p-0 overflow-hidden"
      data-testid={`news-card-${article.id}`}
    >
      {/* Image */}
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={article.image_url}
          alt={article.title}
          className="news-card-image w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>

      {/* Content */}
      <div className="p-5 md:p-6">
        <div className="flex items-center gap-2 mb-3">
          <Badge
            variant="outline"
            className="font-mono text-[9px] uppercase tracking-widest border-stone-300 rounded-none"
          >
            {CATEGORIES[article.category] || article.category}
          </Badge>
          <span className="font-mono text-[9px] text-stone-400 flex items-center gap-1">
            <Clock className="w-2.5 h-2.5" />
            {timeAgo(article.published_at)}
          </span>
        </div>

        <h3
          className="text-lg md:text-xl font-semibold text-stone-900 leading-tight mb-3 group-hover:text-[#1B4F72] transition-colors line-clamp-2"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          {article.title}
        </h3>

        <p className="text-sm text-stone-500 leading-relaxed line-clamp-3 mb-4">
          {article.summary}
        </p>

        <div className="flex items-center justify-between pt-3 border-t border-stone-100">
          <div className="flex items-center gap-3 text-[10px] font-mono text-stone-400 uppercase tracking-widest">
            <span>{article.author}</span>
            <span className="flex items-center gap-1">
              <Eye className="w-2.5 h-2.5" />
              {article.views}
            </span>
          </div>
          <ArrowUpRight className="w-4 h-4 text-stone-300 group-hover:text-[#1B4F72] transition-colors" />
        </div>
      </div>
    </Link>
  );
};
